<template>
  <v-menu
    :close-on-content-click="false"
    v-bind="{
      top,
      bottom,
      right,
      left,
      offsetX,
      offsetY,
    }"
  >
    <template #activator="{ on, attrs }">
      <v-btn
        text
        v-bind="attrs"
        v-on="on"
      >
        <v-icon size="24">
          fas fa-user-circle
        </v-icon>
      </v-btn>
    </template>
    <v-card width="300px">
      <v-container fluid>
        <v-row
          no-gutters
          align="center"
          justify="center"
        >
          <v-card
            width="100%"
            flat
            class="pa-1"
            @click="toAccountPage('basic')"
          >
            <v-row no-gutters>
              <v-avatar
                tile
                size="37"
                color="blue"
              >
                <img
                  v-if="user.avatar"
                  :src="user.avatar"
                >
                <v-icon
                  v-else
                  dark
                >
                  fa fa-user
                </v-icon>
              </v-avatar>
              <div class="pl-4">
                <div class="font-weight-bold">
                  {{ user.name }}
                </div>
                <span class="caption">{{ user.email }}</span>
              </div>
            </v-row>
          </v-card>
        </v-row>
      </v-container>

      <v-divider />

      <v-list>
        <v-list-item
          v-for="tab in tabs"
          :key="`tab-${tab}`"
          @click="toAccountPage(tab)"
          v-text="$t(`core.navigation.account_${tab}`)"
        />
      </v-list>

      <v-divider />

      <div class="text-center py-3 px-5">
        <v-btn
          text
          outlined
          @click="logout"
        >
          SIGN OUT
        </v-btn>
      </div>
    </v-card>
  </v-menu>
</template>

<script>
import { toRhitics } from '@rhitics/utils/links'

export default {
  name: 'UserMenu',

  props: [
    'right',
    'top',
    'bottom',
    'left',
    'offset-x',
    'offset-y'
  ],

  data() {
    return {
      tabs: ['basic', 'preference']
    }
  },

  computed: {
    user() {
      return this.$auth.user
    }
  },

  methods: {
    logout() {
      toRhitics('logout')
    },
    toAccountPage(subPage) {
      toRhitics('account', subPage)
    }
  }
}
</script>
